import { PHONE, locationSchema } from "../structured-data-core";

export function getParamusStructuredData() {
  const url = "https://restorehair.com/locations/new-jersey/paramus/";
  const description =
    "Find out about your hair transplant options in Paramus with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Paramus", "140 E Ridgewood Avenue", "Paramus", "NJ", PHONE, url, description),
  ];
}
